export type PredefinedBasket = {
  id: number;
  friendlyName: string;
  baseAssets: string; // array of numbers separated by ,
  balanceDistribution: string; // array of floats separated by ,
};

export const PredefinedBasketsSortingMap: Record<string, number> = {
  "Owner's Choice": 0,
  'Top 10 Coins': 1,
  'Top 20 Coins': 2,
  'Top 50 Coins': 3,
  'Layer 1 Coins': 4,
  'Layer 2 Coins': 5,
  'Ethereum Ecosystem Coins': 6,
  'Solana Ecosystem Coins': 7,
  'Binance Ecosystem Coins': 8,
  'Cardano Ecosystem Coins': 9,
  'Decentralized Finance Coins': 10,
  'Artificial Intelligence Coins': 11,
  'Real-World Assets Coins': 12,
  'Gaming Coins': 13,
  'Meme Coins': 14,
  'Exchange Coins': 15,
  'Centralized Exchange Coins': 16,
  'Decentralized Exchange Coins': 17,
  'Made in USA Coins': 18,
};
